import { useEffect, useState } from 'react';
import useDealerLocator from '@app/components/dealer-locator/useDealerLocator';
import {
  setSessionStorage,
  getSessionStorage,
  isMLP,
  isCategoryPage,
  isHomepage
} from '@app/utils';
import { useTranslation } from 'react-i18next';
import { SelectDealerFlyout } from '@cat-ecom/pcc-components';
import { ALP_SELECT_DEALER_FLYOUT_SHOWN } from '../../constants';
import FixedNotification from '@app/components/common/FixedNotification';
import { useSelector } from 'react-redux';
import { useOneTrust } from '@app/hooks';

const AddDealerFlyout = () => {
  const [t] = useTranslation();
  const { showDealerLocator } = useDealerLocator();
  const isCatCorp = useSelector(s => s.common.isCatCorp);
  const { equipmentSaveMessage } = useSelector(s => s.myEquipment);
  const [displayFlyout, setDisplayFlyout] = useState(false);
  const { isTargetingAccepted } = useOneTrust();
  const isPlp = isCategoryPage();

  const handleClose = () => {
    setDisplayFlyout(false);
  };
  const onSelectDealer = () => {
    showDealerLocator({});
    handleClose();
  };
  const dealerFlyoutCheck = isMLP() || isPlp || isHomepage();
  useEffect(() => {
    const initialShow = !getSessionStorage(ALP_SELECT_DEALER_FLYOUT_SHOWN);
    const sessionToast = getSessionStorage('pendingToast');
    if (
      dealerFlyoutCheck &&
      !sessionToast &&
      !equipmentSaveMessage &&
      isTargetingAccepted &&
      isCatCorp &&
      initialShow
    ) {
      setSessionStorage(ALP_SELECT_DEALER_FLYOUT_SHOWN, true);
      setDisplayFlyout(true);
    }
  }, [equipmentSaveMessage, isCatCorp, isTargetingAccepted]);

  return (
    displayFlyout && (
      <FixedNotification defaultClose={false}>
        <SelectDealerFlyout
          onClose={handleClose}
          onSelectDealer={onSelectDealer}
          description={t('ALP_DEALER_SECTION_DESCRIPTION')}
          selectLabel={t('CAT_SELECT_STORE')}
          laterLabel={t('ALP_LATER')}
        />
      </FixedNotification>
    )
  );
};

export default AddDealerFlyout;
